import { Component, Input, OnInit } from '@angular/core';

export interface PdfPreviewPopupOption{
  pdfUrl:string;
  showPdf:boolean;
}

@Component({
    selector: 'app-pdf-preview-popup',
    templateUrl: './pdf-preview-popup.component.html',
    styleUrls: ['./pdf-preview-popup.component.less'],
    standalone: false
})
export class PdfPreviewPopupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  @Input() option:PdfPreviewPopupOption;

}
